// node modules
import React from 'react';
import { observer } from 'mobx-react';
// ui library
import { Text, View } from '@upstox/upstox-ui';
// modules
import { useStore } from 'modules/Stores';
import FormatService from 'modules/Format';
// styles
import * as css from '../styles';
// components
import OptionChainCell from '../OptionChainCell/OptionChainCell';

const OptionChainBidCell: React.FC<OptionChainTableCellProps> = ({
  instrumentKey,
  isCall,
}) => {
  const { getOptionParamValueWithInstrumentKey } = useStore('LiveDataStore');

  const buyPrice = getOptionParamValueWithInstrumentKey(
    instrumentKey,
    'buyPrice',
  );

  return (
    <OptionChainCell>
      <View
        flex
        alignItems={isCall ? 'flex-start' : 'flex-end'}
        justifyContent="center"
      >
        <Text
          variant="meta"
          color="text.1"
          size="m"
          lineHeight="l"
          css={css.optionChainCell}
        >
          {buyPrice ? FormatService.formatToIndianFloat(buyPrice) : '--'}
        </Text>
      </View>
    </OptionChainCell>
  );
};

export default observer(OptionChainBidCell);
